import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { PrimeTemplate } from 'primeng/api';
import { BrandService } from '../../branding/brand.service';
import { brandAssets, type Brand } from '../../branding/brand';

interface BrandOption {
  value: Brand;
  label: string;
  icon: string;
}

/**
 * Manual brand switch, shown only where the server leaves the brand undecided (localhost).
 * p-select instead of app-select: the options need an icon template (see 06-angular-patterns).
 */
@Component({
  selector: 'app-brand-selector',
  templateUrl: './brand-selector.component.html',
  styleUrl: './brand-selector.component.scss',
  imports: [FormsModule, SelectModule, PrimeTemplate],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandSelectorComponent {
  private readonly brandService = inject(BrandService);

  // Brand names are proper nouns: not translated.
  readonly options: BrandOption[] = (['homeserve', 'reparalia'] as Brand[]).map(value => ({
    value,
    label: brandAssets(value).name,
    icon: brandAssets(value).mark,
  }));

  readonly brand = this.brandService.brand;

  onBrandChange(brand: Brand): void {
    this.brandService.apply(brand);
  }
}
